<template>
  <div class="new-detail">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('工作流程') }}</span>
      <span></span>
    </header>
    <div class="article">
      <div class="title">{{ $t('货物转运流程') }}</div>
      <div class="desc">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item title="转运须知" name="1">
            <p>
              1、什么是敏感货？发敏感货的注意事项？<br />
              “敏感货”主要指那些涉及到征出口税的、涉及到版权或政治因素的商品，
              还有些类似违禁品的货品也属于敏感货。例如：电子产品、电池等带电或带磁性的物品（手机、平板电脑、磁铁、剃须刀、刀片等）、名牌、仿牌、化妆品、食品
              （东马不可以寄）、光碟、成人用品（情趣用品）、马达、液体、粉体、膏体、手表等。敏感货物请提前咨询。
              有些是目的国要进口准证的，有些是我们不能出或限量出的有些货特别时期不能出的。
              <br />
              新加坡海关规定：食品类都需要许可证。<br />
              肉类及制品、海鲜类及制品、奶类及制品、酒精类及制品程序特别严格不能清关。<br />
              2、体积重是什么意思？ 海运/空运怎么计费？<br />
              体积重：航空公司规定，在货物体积小，重量大时，按实际重量计算；在货物体积大，重量小时，按体积计算。体积重量
              公式为：长度（厘米cm）X宽度（厘米cm）X高度（厘米cm）/6000 。<br />
              空运运费=价格*计费重量（实重或体积重，取较大者），重量不足0.5kg或不足1kg的，按0.5kg或1kg计算。<br />
              海运小包运费=价格*计费重量（实重或体积重，取较大者）<br />
              海运大件运费=方数x价格，方数最低消费：马来西亚0.30CBM,新加坡1.00CBM<br />
              3、可以集运到哪里？<br />
              目前集运有以下集运线路：马来西亚、新加坡、菲律宾、越南、泰国、柬埔寨等。
              4、违禁品有哪些？<br />
              <a
                class="btn btn-primary"
                @click="
                  $router.push({
                    name: 'NewsDetail',
                    query: { key: '违禁品告示' },
                  })
                "
                >参考违禁品告示</a
              >
            </p>
          </van-collapse-item>
          <van-collapse-item title="违禁品告示" name="2">
            <van-button
              @click="
                $router.push({
                  name: 'NewsDetail',
                  query: { key: '违禁品告示' },
                })
              "
              type="warning"
              >{{ $t('违禁品告示') }}</van-button
            >
          </van-collapse-item>
        </van-collapse>
        <div class="sec-title">{{ $t('简单四步，开始您的集运') }}</div>
        <van-steps :active="active">
          <van-step>1.发货到集货仓</van-step>
          <van-step>2.货物预报</van-step>
          <van-step>3.集包发货</van-step>
          <van-step>4.目的地收货</van-step>
        </van-steps>
        <van-grid class="text-center" clickable>
          <van-grid-item
            icon="wap-home"
            @click="$router.push({ name: 'RecStorageAddr' })"
            text="购物，发货到集运仓库"
          />
          <van-grid-item
            icon="todo-list"
            @click="$router.push({ name: 'EnterPackage' })"
            text="预报货物，开始转运"
          />
          <van-grid-item
            icon="point-gift"
            @click="$router.push({ name: 'Deliver' })"
            text="申请集包，支付订单发货"
          />
          <van-grid-item
            icon="bill"
            @click="$router.push({ name: 'Orders' })"
            text="货物到目的地后，签收"
          />
        </van-grid>
      </div>

      <div class="content">
        <div class="sec-title">{{ $t('货物详细转运流程') }}</div>
        <div class="steps-timeline">
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">您的货物打包发到我们集运仓库</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">根据您的指令我们打包测量装柜</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">办理国内货物报关手续</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">装船/装机运输至目的地</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">目的地国家港口海关清关</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">货物送达监管仓库（支持自提或配送）</div>
          </div>
          <div class="step-item">
            <div class="step-number"></div>
            <div class="step-content">完成送货上门签收</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASE_URL } from '@/api/index.js';
import { getFirmInfo } from '@/api/website.js';
import Vue from 'vue';
import { Collapse, CollapseItem } from 'vant';
import { Step, Steps } from 'vant';

Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.use(Step);
Vue.use(Steps);
// import { formatDate } from '@/utils/index.js';
// function getValidTime(value) {
//   if (value == null || value == '') return '';
//   var myDate = new Date(value.match(/\d+/)[0] * 1);
//   return formatDate(myDate);
// }
export default {
  data() {
    return {
      CompanyName: '',
      CompanyObligation: '',
      activeName: 1,
      active: 4,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {},
  methods: {
    htmlDecode(text) {
      //1.首先动态创建一个容器标签元素，如DIV
      var temp = document.createElement('div');
      //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
      temp.innerHTML = text;
      //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
      var output = temp.innerText || temp.textContent;
      temp = null;
      console.log(output);
      return output;
    },
    loadData() {
      getFirmInfo().then(res => {
        if (res.Result == true) {
          let data = res.DataDict['data'];
          console.log(res);
          this.CompanyName = data.CompanyName;
          this.CompanyObligation = data.CompanyObligation;
          this.CompanyPhone = data.CompanyPhone;
          if (data.CompanyPresentationImg.startsWith('http')) {
            this.CompanyPresentationImg = data.CompanyPresentationImg;
          } else {
            this.CompanyPresentationImg =
              BASE_URL + data.CompanyPresentationImg;
          }
          this.CompanyQQ = data.CompanyQQ;
          this.CompanyResume = data.CompanyResume;
          this.CompanySummary = data.CompanySummary;
          this.CompanyTel = data.CompanyTel;
          this.CompanyVision = data.CompanyVision;
          this.CompanyWechat = data.CompanyWechat;
          if (data.WechatPicUrl.startsWith('http')) {
            this.WechatPicUrl = data.WechatPicUrl;
          } else {
            this.WechatPicUrl = BASE_URL + data.WechatPicUrl;
          }
          this.CompanyMission = data.CompanyMission;
          this.CompanyMail = data.CompanyMail;
          this.CompanyLinkMan = data.CompanyLinkMan;
          this.CompanyAddr = data.CompanyAddr;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_var';

.article {
  margin: rem(20px);
  margin-top: rem(100px);
  line-height: 0.6rem;
  background: #fff;
  max-width: 100%;
  padding: rem(20px);

  .title {
    font-size: rem(40px);
    text-align: left;
    padding: rem(15px);
  }

  .img img {
    width: 100%;
    height: rem(260px);
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .content {
    img {
      max-width: 100%;
    }
  }

  .author {
    font-size: rem(18px);
    padding: rem(15px);
  }

  img {
    max-width: 100%;
  }

  .text-center {
    text-align: center;
  }

  .btn-primary {
    color: #2196f3;
  }

  .sec-title {
    font-family: PingFang-SC-Medium;
    font-size: 16px;
    color: #3a3a3a;
    letter-spacing: 0;
    padding: 0px;
    border-left: solid #484744 9px;
    padding-left: 15px;
    margin-left: 12px;
  }

  .steps-timeline {
    position: relative;
    max-width: 800px;
    margin: 10px auto;
    padding-left: 30px;
    counter-reset: step;
  }

  .steps-timeline:before {
    content: '';
    position: absolute;
    left: 12px;
    top: 0;
    height: 100%;
    width: 2px;
    background: #e0e0e0;
  }

  .step-item {
    position: relative;
    margin-bottom: 30px;
    padding-left: 40px;
  }

  .step-item:last-child {
    margin-bottom: 0;
  }

  .step-number {
    position: absolute;
    left: 0;
    top: 0;
    width: 26px;
    height: 26px;
    background: #2196f3;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    counter-increment: step;
  }

  .step-number:before {
    content: counter(step);
  }

  .step-content {
    background: #f5f5f5;
    padding: 15px 20px;
    border-radius: 8px;
    line-height: 1.6;
    position: relative;
  }

  .step-content:before {
    content: '';
    position: absolute;
    left: -10px;
    top: 12px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #f5f5f5;
  }
}
</style>
